// extracted by mini-css-extract-plugin
export default {"productListConatiner":"ProductsList_productListConatiner__DNqx9"};